class CartCrossSell extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('form');
    this.form.addEventListener(
        'submit',
        this.onSubmitHandler.bind(this)
    );
    this.submitButton = this.form.querySelector('[name="add"]');
    this.cartDrawer = document.querySelector('cart-drawer');
    this.cartDrawerBody = document.querySelector('#CartDrawer-Body');

    this.variantsJson = this.querySelector('[type="application/json"]');
    if (this.variantsJson) {
      this.variants = JSON.parse(this.variantsJson.textContent);
      this.addEventListener('change', this.onVariantChange.bind(this));
    }
  }

  onVariantChange(event) {
    if (event.target.type === 'number') return;

    this.updateOptions();
    this.updateVariant();
    this.updateVariantInput();
    this.updateImage();
  }

  updateImage() {
    const mediaElement = this.querySelector('.cart-cross-sell-grid__media');
    if (!mediaElement) return;

    // Get variant image or use default product image
    let newImage;
    let imageSrc;

    if (this.currentVariant?.featured_image) {
      newImage = this.currentVariant.featured_image;
      imageSrc = newImage.src;
    } else {
      try {
        const defaultImageData = mediaElement.dataset.defaultImage;
        if (defaultImageData) {
          const decodedData = defaultImageData
              .replace(/&quot;/g, '"')
              .replace(/&apos;/g, "'")
              .replace(/&amp;/g, '&');

          newImage = JSON.parse(decodedData);
          imageSrc = newImage.src;
        }
      } catch (error) {
        console.error('Error parsing default image data:', error);
        return;
      }
    }

    if (!imageSrc) return;

    // Check if current image is the same as new image
    const currentImg = mediaElement.querySelector('img');
    if (currentImg) {
      // Get product path from URL
      const getProductPath = (src) => {
        // Try to get path after /products/ or /files/
        const matches = src.match(/\/(?:products|files)\/([^?]+)/);
        return matches ? matches[1] : '';
      };

      const currentPath = getProductPath(currentImg.src);
      const newPath = getProductPath(imageSrc);

      if (currentPath && newPath && currentPath === newPath) {
        // Images are the same, no need to update
        return;
      }
    }

    // Create new image element with required attributes
    const imgElement = document.createElement('img');
    imgElement.src = imageSrc;
    imgElement.alt = this.currentVariant?.title || '';
    imgElement.width = newImage.width || '';
    imgElement.height = newImage.height || '';
    imgElement.loading = 'lazy';
    imgElement.decoding = 'async';

    // Set responsive image srcset
    const srcset = [];
    [180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048].forEach(width => {
      srcset.push(`${imageSrc}&width=${width} ${width}w`);
    });
    imgElement.srcset = srcset.join(', ');
    imgElement.sizes = '(min-width: 990px) 90vw, 95vw';

    // Add fade effect
    imgElement.style.opacity = '0';
    imgElement.style.transition = 'opacity 0.3s ease';

    // Show image after it's loaded
    imgElement.onload = () => {
      imgElement.style.opacity = '1';
    };

    // Handle image replacement with fade effect
    if (currentImg) {
      currentImg.style.opacity = '0';
      setTimeout(() => {
        currentImg.replaceWith(imgElement);
      }, 300);
    } else {
      mediaElement.innerHTML = '';
      mediaElement.appendChild(imgElement);
      setTimeout(() => {
        imgElement.style.opacity = '1';
      }, 50);
    }
  }


  updateOptions() {
    this.options = Array.from(
        this.querySelectorAll('input[type="radio"]:checked, select'),
        (el) => el.value
    );
  }

  updateVariant() {
    if (!this.variants) return;

    this.currentVariant = this.variants.find((variant) => {
      return !variant.options
          .map((option, index) => this.options[index] === option)
          .includes(false);
    });
  }

  updateVariantInput() {
    if (!this.currentVariant) return;

    const input = this.querySelector('[name="id"]');
    if (input) input.value = this.currentVariant.id;
  }

  onSubmitHandler(event) {
    event.preventDefault();

    this.submitButton.classList.add('disabled');

    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
    const formData = new FormData(this.form);
    formData.append(
        'sections',
        this.cartDrawer
            .getSectionsToRender()
            .map((section) => section.section)
    );
    formData.append('sections_url', window.location.pathname);
    config.body = formData;

    fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }

          this.cartDrawer.renderContents(response);
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          this.submitButton.classList.remove('disabled');
          this.cartDrawerBody.scrollTo({top: 0, behavior: 'smooth'});
        });
  }

  handleErrorMessage(errorMessage = false) {
    const errorWrapper = this.querySelector('[data-error-wrapper]');
    if (!errorWrapper) return;
    errorWrapper.classList.toggle('hidden', !errorMessage);
    errorWrapper.textContent = errorMessage || '';
  }
}

customElements.define('cart-update-button', CartCrossSell);
